<template>
  <Modal
    :close-triggers="['click-outside', 'close-button', 'escape']"
    no-cancel
    :tracking="{
      action: 'checkout',
      topicKey: 'cut-off-time-exceeded',
    }"
  >
    <template #headline>
      {{ $t('lottery.closingtime.modal.headline') }}
    </template>
    <template #confirm>
      {{ $t('lottery.closingtime.modal.confirm') }}
    </template>

    <p>{{ message }}</p>

    <Illustration class="mt-200" name="cutoff-time-over" />
  </Modal>
</template>

<script lang="ts" setup>
type LotteryCutoffTimeModalProps = {
  nextDrawDate?: Date | string
  prevDrawDate: Date | string
}

const { nextDrawDate, prevDrawDate } = defineProps<LotteryCutoffTimeModalProps>()

const { locale, t } = useI18n()

const message = computed(() => {
  const prevDraw = formatDate(prevDrawDate, 'drawingTime', undefined, locale.value)

  if (!nextDrawDate) {
    return t('lottery.closingtime.modal.nonextdraw.message', { prevDrawDate: prevDraw })
  }

  return t('lottery.closingtime.modal.message', {
    nextDrawDate: formatDate(nextDrawDate, 'drawingShort', undefined, locale.value),
    prevDrawDate: prevDraw,
  })
})
</script>
